import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import DieuXeService from "services/Asset/DieuXe/Index";

export const getTaiXe = createAsyncThunk(
  "taiXe/getTaiXe",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DieuXeService.GetAllDrivers(data);
      // Handle the response structure properly
      return {
        data: response.data.data || [],
        total: response.data.totalCount || 0,
      };
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createTaiXe = createAsyncThunk(
  "taiXe/createTaiXe",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      await DieuXeService.CreateDrivers(payload);
      if (onSuccess) onSuccess({ success: true });
      return payload;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.description || "Error");
    }
  },
);

export const deleteTaiXe = createAsyncThunk(
  "taiXe/deleteTaiXe",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      await DieuXeService.DeleteDrivers(id);
      if (onSuccess) onSuccess({ success: true });
      return id;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);

export const updateDriverIsUse = createAsyncThunk(
  "taiXe/updateDriverIsUse",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id, isUse } = data;
    try {
      await DieuXeService.UpdateDriverIsUse({ id, isUse });
      if (onSuccess) onSuccess({ success: true });
      return { id, isUse };
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  },
);
const initialState = {
  loading: false,
  taiXeList: [],
  taiXeTotalCount: 0,
  taiXeDetail: {
    data: null,
    loading: false,
  },
};

const taiXeSlice = createSlice({
  name: "taiXe",
  initialState,
  reducers: {
    resetTaiXeDetail: (state) => {
      state.taiXeDetail = {
        data: null,
        loading: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTaiXe.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTaiXe.fulfilled, (state, action) => {
        state.loading = false;
        state.taiXeList = action.payload.data;
        state.taiXeTotalCount = action.payload.total;
      })
      .addCase(getTaiXe.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createTaiXe.pending, (state) => {
        state.loading = true;
      })
      .addCase(createTaiXe.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createTaiXe.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteTaiXe.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTaiXe.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteTaiXe.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateDriverIsUse.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDriverIsUse.fulfilled, (state, action) => {
        state.loading = false;
        // Update the isUse status in the list
        const { id, isUse } = action.payload;
        const index = state.taiXeList.findIndex(item => item.id === id);
        if (index !== -1) {
          state.taiXeList[index].isUse = isUse;
        }
      })
      .addCase(updateDriverIsUse.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { resetTaiXeDetail } = taiXeSlice.actions;

export default taiXeSlice.reducer;
